import { lazyLoad } from 'utils/loadable';

export const UserPackagesReports = lazyLoad(() => import('./index'));
